const currencyCodes= [
    {
      "currencyCode": "AED",
      "currencyDesc": "United Arab Emirates Dirham"
    },
    {
      "currencyCode": "AFN",
      "currencyDesc": "Afghanistan Afgani"
    },
    {
      "currencyCode": "ALL",
      "currencyDesc": "Albanian Lek"
    },
    {
      "currencyCode": "AMD",
      "currencyDesc": "Armenia Dram"
    },
    {
      "currencyCode": "ANG",
      "currencyDesc": "Netherland Antilles Guilder"
    },
    {
      "currencyCode": "AOA",
      "currencyDesc": "Angolan Kwanza"
    },
    {
      "currencyCode": "ARS",
      "currencyDesc": "Argentine Peso"
    },
    {
      "currencyCode": "ARU",
      "currencyDesc": "Aruban Florin"
    },
    {
      "currencyCode": "ATS",
      "currencyDesc": "Austrian Schilling"
    },
    {
      "currencyCode": "AUD",
      "currencyDesc": "Australian Dollar"
    },
    {
      "currencyCode": "AWG",
      "currencyDesc": "Aruban Guilder"
    },
    {
      "currencyCode": "AZN",
      "currencyDesc": "Azerbaijani Manat"
    },
    {
      "currencyCode": "BAM",
      "currencyDesc": "Bosnia-Herzegovina"
    },
    {
      "currencyCode": "BBD",
      "currencyDesc": "Barbados Dollar"
    },
    {
      "currencyCode": "BDT",
      "currencyDesc": "Bangladesh Taka"
    },
    {
      "currencyCode": "BEF",
      "currencyDesc": "Belgian Franc"
    },
    {
      "currencyCode": "BGN",
      "currencyDesc": "Bulgarian Lev"
    },
    {
      "currencyCode": "BHD",
      "currencyDesc": "Bahraini Dinar"
    },
    {
      "currencyCode": "BHR",
      "currencyDesc": "Bahraini dinar"
    },
    {
      "currencyCode": "BMD",
      "currencyDesc": "Bermudian Dollar"
    },
    {
      "currencyCode": "BOB",
      "currencyDesc": "Bolivian Boliviano"
    },
    {
      "currencyCode": "BRL",
      "currencyDesc": "Brazilian Real"
    },
    {
      "currencyCode": "BSD",
      "currencyDesc": "Bahama Dollars"
    },
    {
      "currencyCode": "BWP",
      "currencyDesc": "Botswana Pula"
    },
    {
      "currencyCode": "BYN",
      "currencyDesc": "Belarus Ruble Spot"
    },
    {
      "currencyCode": "BZD",
      "currencyDesc": "Belize Dollar"
    },
    {
      "currencyCode": "CAD",
      "currencyDesc": "Canadian Dollar"
    },
    {
      "currencyCode": "CDF",
      "currencyDesc": "Congolais Franc"
    },
    {
      "currencyCode": "CHF",
      "currencyDesc": "Swiss Franc"
    },
    {
      "currencyCode": "CLF",
      "currencyDesc": "Chilean Unidad de Fomento"
    },
    {
      "currencyCode": "CLP",
      "currencyDesc": "Chilean Peso"
    },
    {
      "currencyCode": "CNH",
      "currencyDesc": "Offshore Chinese Renminbi Spot"
    },
    {
      "currencyCode": "CNY",
      "currencyDesc": "Chinese Renminbi Spot"
    },
    {
      "currencyCode": "COF",
      "currencyDesc": "Unrealized FX Gain/Loss"
    },
    {
      "currencyCode": "COP",
      "currencyDesc": "Colombian Peso"
    },
    {
      "currencyCode": "COU",
      "currencyDesc": "Colombian Unidad de Valor Real"
    },
    {
      "currencyCode": "CRC",
      "currencyDesc": "Costa Rican Colon"
    },
    {
      "currencyCode": "CYP",
      "currencyDesc": "Cyprus Pound"
    },
    {
      "currencyCode": "CZK",
      "currencyDesc": "Czech Koruna"
    },
    {
      "currencyCode": "DEM",
      "currencyDesc": "German Deutschmark"
    },
    {
      "currencyCode": "DKK",
      "currencyDesc": "Danish Krone"
    },
    {
      "currencyCode": "DOP",
      "currencyDesc": "Dominican Republic Peso"
    },
    {
      "currencyCode": "DZD",
      "currencyDesc": "Algerian dinar"
    },
    {
      "currencyCode": "ECS",
      "currencyDesc": "Ecuadorian Sucre"
    },
    {
      "currencyCode": "EGP",
      "currencyDesc": "Egyptian Pound"
    },
    {
      "currencyCode": "ESP",
      "currencyDesc": "Spanish Peseta"
    },
    {
      "currencyCode": "EUR",
      "currencyDesc": "Euro"
    },
    {
      "currencyCode": "FIM",
      "currencyDesc": "Finnish Markka"
    },
    {
      "currencyCode": "FJD",
      "currencyDesc": "Fiji Dollar"
    },
    {
      "currencyCode": "FRF",
      "currencyDesc": "French Franc"
    },
    {
      "currencyCode": "FRW",
      "currencyDesc": "Rwandan Franc"
    },
    {
      "currencyCode": "GBP",
      "currencyDesc": "British Pound Sterling"
    },
    {
      "currencyCode": "GEL",
      "currencyDesc": "Georgia Lari"
    },
    {
      "currencyCode": "GHC",
      "currencyDesc": "Ghana Cedi"
    },
    {
      "currencyCode": "GHS",
      "currencyDesc": "New Ghana Cedi"
    },
    {
      "currencyCode": "GRD",
      "currencyDesc": "Greek Drachma"
    },
    {
      "currencyCode": "GTQ",
      "currencyDesc": "Guatemala Quetzal Spot"
    },
    {
      "currencyCode": "GYD",
      "currencyDesc": "Guyana Dollar"
    },
    {
      "currencyCode": "HKD",
      "currencyDesc": "Hong Kong Dollar"
    },
    {
      "currencyCode": "HNL",
      "currencyDesc": "Honduran Lempira"
    },
    {
      "currencyCode": "HRK",
      "currencyDesc": "Croatian Kuna"
    },
    {
      "currencyCode": "HTG",
      "currencyDesc": "Haiti Gourde"
    },
    {
      "currencyCode": "HUF",
      "currencyDesc": "Hungarian Forint"
    },
    {
      "currencyCode": "IDR",
      "currencyDesc": "Indonesian Rupiah"
    },
    {
      "currencyCode": "IEP",
      "currencyDesc": "Irish Punt"
    },
    {
      "currencyCode": "ILS",
      "currencyDesc": "Israeli Shekel"
    },
    {
      "currencyCode": "INR",
      "currencyDesc": "Indian Rupee"
    },
    {
      "currencyCode": "IQD",
      "currencyDesc": "Iraqi Dinar"
    },
    {
      "currencyCode": "IRR",
      "currencyDesc": "Iranian Rial"
    },
    {
      "currencyCode": "ISK",
      "currencyDesc": "Iceland Krona"
    },
    {
      "currencyCode": "ITL",
      "currencyDesc": "Italian Lira"
    },
    {
      "currencyCode": "JMD",
      "currencyDesc": "Jamaica Dollar"
    },
    {
      "currencyCode": "JOD",
      "currencyDesc": "Jordanian Dinar"
    },
    {
      "currencyCode": "JPY",
      "currencyDesc": "Japanese Yen"
    },
    {
      "currencyCode": "KES",
      "currencyDesc": "Kenyan Shilling"
    },
    {
      "currencyCode": "KGS",
      "currencyDesc": "Kyrgyzstan Som"
    },
    {
      "currencyCode": "KRW",
      "currencyDesc": "South Korean Won"
    },
    {
      "currencyCode": "KWD",
      "currencyDesc": "Kuwaiti Dinar"
    },
    {
      "currencyCode": "KYD",
      "currencyDesc": "Cayman Island Dollar"
    },
    {
      "currencyCode": "KZT",
      "currencyDesc": "Kazakhstan Tenge"
    },
    {
      "currencyCode": "LBP",
      "currencyDesc": "Lebanese Pond"
    },
    {
      "currencyCode": "LKR",
      "currencyDesc": "Sri Lanka Rupee"
    },
    {
      "currencyCode": "LRD",
      "currencyDesc": "Liberian Dollar"
    },
    {
      "currencyCode": "LTL",
      "currencyDesc": "Lithuania Lit"
    },
    {
      "currencyCode": "LUF",
      "currencyDesc": "Luxembourg Franc"
    },
    {
      "currencyCode": "LVL",
      "currencyDesc": "Lativia Lat"
    },
    {
      "currencyCode": "MAD",
      "currencyDesc": "Moroccan Dirham"
    },
    {
      "currencyCode": "MDL",
      "currencyDesc": "Moldovan Leu"
    },
    {
      "currencyCode": "MKD",
      "currencyDesc": "Macedonia Denar"
    },
    {
      "currencyCode": "MMK",
      "currencyDesc": "Myanmar Kyat"
    },
    {
      "currencyCode": "MNT",
      "currencyDesc": "Mongolian Tugrik Spot"
    },
    {
      "currencyCode": "MRO",
      "currencyDesc": "Mauritania Ouguiya"
    },
    {
      "currencyCode": "MRU",
      "currencyDesc": "Mauritania Quguiya"
    },
    {
      "currencyCode": "MTL",
      "currencyDesc": "Malta Lira"
    },
    {
      "currencyCode": "MUR",
      "currencyDesc": "Mauritius Rupee"
    },
    {
      "currencyCode": "MWK",
      "currencyDesc": "Malawian Kwacha Spot"
    },
    {
      "currencyCode": "MXN",
      "currencyDesc": "Mexican Peso"
    },
    {
      "currencyCode": "MXV",
      "currencyDesc": "Mexican Unidad de Inversion"
    },
    {
      "currencyCode": "MYF",
      "currencyDesc": "Malaysian Ringgit Offshore"
    },
    {
      "currencyCode": "MYR",
      "currencyDesc": "Malaysian Ringgit"
    },
    {
      "currencyCode": "MZN",
      "currencyDesc": "Mozambique New Metical"
    },
    {
      "currencyCode": "NAD",
      "currencyDesc": "Namibia Dollar"
    },
    {
      "currencyCode": "NGN",
      "currencyDesc": "Nigeria Naira"
    },
    {
      "currencyCode": "NLG",
      "currencyDesc": "Netherlands Guilder"
    },
    {
      "currencyCode": "NOK",
      "currencyDesc": "Norwegian Krone"
    },
    {
      "currencyCode": "NZD",
      "currencyDesc": "New Zealand Dollar"
    },
    {
      "currencyCode": "OMR",
      "currencyDesc": "Omani Rial"
    },
    {
      "currencyCode": "PAB",
      "currencyDesc": "Panamanian Balboa"
    },
    {
      "currencyCode": "PEN",
      "currencyDesc": "Peruvian New Sol"
    },
    {
      "currencyCode": "PGK",
      "currencyDesc": "Papua & New Guinea Kina"
    },
    {
      "currencyCode": "PHP",
      "currencyDesc": "Philippine Peso"
    },
    {
      "currencyCode": "PKR",
      "currencyDesc": "Pakistan Rupee"
    },
    {
      "currencyCode": "PLN",
      "currencyDesc": "Polish Zloty"
    },
    {
      "currencyCode": "PSS",
      "currencyDesc": "Peruvian Sol"
    },
    {
      "currencyCode": "PTE",
      "currencyDesc": "Portugese Escudo"
    },
    {
      "currencyCode": "PYG",
      "currencyDesc": "Paraguay Gurani"
    },
    {
      "currencyCode": "QAR",
      "currencyDesc": "Qatari Riyal"
    },
    {
      "currencyCode": "RON",
      "currencyDesc": "New Romanian Leu"
    },
    {
      "currencyCode": "RSD",
      "currencyDesc": "Serbian Dinar"
    },
    {
      "currencyCode": "RUB",
      "currencyDesc": "Russian Ruble"
    },
    {
      "currencyCode": "RWF",
      "currencyDesc": "Rwanda Franc"
    },
    {
      "currencyCode": "SAR",
      "currencyDesc": "Saudi Rival"
    },
    {
      "currencyCode": "SEK",
      "currencyDesc": "Swedish Krona"
    },
    {
      "currencyCode": "SGD",
      "currencyDesc": "Singapore Dollar"
    },
    {
      "currencyCode": "SIT",
      "currencyDesc": "Slovenia Tolar"
    },
    {
      "currencyCode": "SKK",
      "currencyDesc": "Slovakia Koruna"
    },
    {
      "currencyCode": "SND",
      "currencyDesc": "Supra National"
    },
    {
      "currencyCode": "SRD",
      "currencyDesc": "Surinamese Dollar"
    },
    {
      "currencyCode": "SVC",
      "currencyDesc": "Salvadoran Colon"
    },
    {
      "currencyCode": "SYP",
      "currencyDesc": "Syrian Pound"
    },
    {
      "currencyCode": "SZL",
      "currencyDesc": "Swaziland Liilangeni"
    },
    {
      "currencyCode": "TBA",
      "currencyDesc": "TBA CASH"
    },
    {
      "currencyCode": "THB",
      "currencyDesc": "Thailand Baht"
    },
    {
      "currencyCode": "TND",
      "currencyDesc": "Tunisian Dinar"
    },
    {
      "currencyCode": "TRL",
      "currencyDesc": "Turkish Lira"
    },
    {
      "currencyCode": "TRY",
      "currencyDesc": "New Turkish Lira"
    },
    {
      "currencyCode": "TTD",
      "currencyDesc": "Trinidad Dollar"
    },
    {
      "currencyCode": "TWD",
      "currencyDesc": "Taiwan Dollar"
    },
    {
      "currencyCode": "TZS",
      "currencyDesc": "Tanzanian Shilling"
    },
    {
      "currencyCode": "UAH",
      "currencyDesc": "Ukraine Hryvna"
    },
    {
      "currencyCode": "UGX",
      "currencyDesc": "Ugandan Shilling"
    },
    {
      "currencyCode": "USD",
      "currencyDesc": "US Dollar"
    },
    {
      "currencyCode": "UYU",
      "currencyDesc": "Uruguay Peso"
    },
    {
      "currencyCode": "VEB",
      "currencyDesc": "Venezuelan Bolivar"
    },
    {
      "currencyCode": "VEF",
      "currencyDesc": "Venezuelan Bolivar Fuerte"
    },
    {
      "currencyCode": "VES",
      "currencyDesc": "Venezuelan Bolivar Sobernaros"
    },
    {
      "currencyCode": "VND",
      "currencyDesc": "Vietnamese Dong"
    },
    {
      "currencyCode": "XAF",
      "currencyDesc": "CFA Franc Beac"
    },
    {
      "currencyCode": "XCD",
      "currencyDesc": "East Caribbean dollar"
    },
    {
      "currencyCode": "XDR",
      "currencyDesc": "Special Drawing Rights"
    },
    {
      "currencyCode": "XEU",
      "currencyDesc": "European ECU"
    },
    {
      "currencyCode": "XOF",
      "currencyDesc": "CFA Franc BCEAO"
    },
    {
      "currencyCode": "ZAR",
      "currencyDesc": "South African Rand"
    },
    {
      "currencyCode": "ZMK",
      "currencyDesc": "Zambian Kwacha"
    },
    {
      "currencyCode": "ZMW",
      "currencyDesc": "New Zambian Kwacha"
    },
    {
      "currencyCode": "ZWD",
      "currencyDesc": "Zimbabwe Dollar"
    },
    {
      "currencyCode": "ZWR",
      "currencyDesc": "Zimbabwe New Dollar"
    }
  ]

 export const ccColumnDef= [
    {
      headerName: 'Currency Code',
      field: 'currencyCode',
     // width: 60,
      suppressSizeToFit: true
    },
    {
      headerName: 'Name',
      field: 'currencyDesc',
     // width: 250
    }
  ]

export default currencyCodes